import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/MarketplaceAffiliateJoinedInfluencers.graphql';
import { Query, QuerymarketplaceAffiliateJoinedInfluencersArgs } from '../../__generated__/globalTypes';

export const useMarketplaceAffiliateJoinedInfluencersQuery = (
  options?: QueryHookOptions<Query, QuerymarketplaceAffiliateJoinedInfluencersArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerymarketplaceAffiliateJoinedInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useMarketplaceAffiliateJoinedInfluencersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerymarketplaceAffiliateJoinedInfluencersArgs>
): QueryResult<Query, QuerymarketplaceAffiliateJoinedInfluencersArgs> & {
  getMarketplaceAffiliateJoinedInfluencers: LazyQueryExecFunction<
    Query,
    QuerymarketplaceAffiliateJoinedInfluencersArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getMarketplaceAffiliateJoinedInfluencers, result] = useLazyQuery<
    Query,
    QuerymarketplaceAffiliateJoinedInfluencersArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getMarketplaceAffiliateJoinedInfluencers, ...result };
};

export const useMarketplaceAffiliateJoinedInfluencersPromiseQuery = () => {
  const client = useApolloClient();

  const getMarketplaceAffiliateJoinedInfluencers = useCallback(
    (options?: Omit<QueryOptions<QuerymarketplaceAffiliateJoinedInfluencersArgs, Query>, 'query'>) =>
      client.query<Query, QuerymarketplaceAffiliateJoinedInfluencersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getMarketplaceAffiliateJoinedInfluencers };
};
// Suspense Query Hooks
export const useMarketplaceAffiliateJoinedInfluencersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerymarketplaceAffiliateJoinedInfluencersArgs>
) => {
  const result = useSuspenseQuery<Query, QuerymarketplaceAffiliateJoinedInfluencersArgs>(QUERY, {
    ...options
  });

  return result;
};
